import Vuex from 'vuex'
import Vue from "vue";
const debug = process.env.NODE_ENV !== 'production'
import products from "./modules/products"
import user from "./modules/user"
import jobs from "./modules/jobs"
import errors from "./modules/errors"

Vue.use(Vuex)

export default new Vuex.Store({
    strict: debug,
    modules: {products, user, jobs, errors}
})